var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/* eslint-disable prettier/prettier */
/* eslint-disable complexity */
import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { Empty, Tabs } from 'antd';
import SearchContactsList from './SearchContactsList';
import { flatten, trim as lodashTrim, includes as lodashIncludes } from 'lodash';
import { SearchType, SelectorMode, } from '../types';
import UserSelectionContext from '../context';
import { mapSearchCustomMember, searchDataMapList, } from '../common';
import Loading from '../../Loading';
import SearchDepartmentList from './SearchDepartmentList';
import SearchInput from '../search/Input';
import { LoadMore } from '../../List';
import SearchGroupList from './SearchGroupList';
import SearchAllList from './SearchAllList';
import searchNodata from '../../images/search-nodata.png';
import ListEmptyPlaceholder from '../../ListEmptyPlaceholder';
import searchIcon from '../../images/app_ic_search.png';
import InputAreaContext from '../../UserSelectionModal/context';
import colors from '../../style/less/colors';
var TabPane = Tabs.TabPane;
var pageNo = 1;
var PAGE_SIZE = 15;
var count = 0;
function GlobalSearchModal(_a) {
    var _this = this;
    var result = _a.result, onItemCheck = _a.onItemCheck, onSearchGlobal = _a.onSearchGlobal, jumpCurrentTabsGroup = _a.jumpCurrentTabsGroup, jumpCurrentTabsOrg = _a.jumpCurrentTabsOrg, handleSetSearchValue = _a.handleSetSearchValue, searchValue = _a.searchValue, onSearchGroupMember = _a.onSearchGroupMember, getSearchExtraPart = _a.getSearchExtraPart, onAnalysisLog = _a.onAnalysisLog, onInputStrangerLeaveWordChange = _a.onInputStrangerLeaveWordChange;
    var _b = React.useContext(UserSelectionContext), t = _b.t, frozenIds = _b.frozenIds, single = _b.single, defaultUserAvatar = _b.defaultUserAvatar, currentUser = _b.currentUser, contactShowType = _b.contactShowType, tabs = _b.tabs, bodyHeight = _b.bodyHeight, chooseOnlyDepart = _b.chooseOnlyDepart, customTabs = _b.customTabs, selectGroupType = _b.selectGroupType, canSelectDept = _b.canSelectDept, dataListFilter = _b.dataListFilter, canSelectStranger = _b.canSelectStranger, setSearchValue = _b.setSearchValue;
    var _c = React.useContext(InputAreaContext), setNewMode = _c.setNewMode, strangerLeaveWordInput = _c.strangerLeaveWordInput;
    var _d = useState(false), isChange = _d[0], setIsChange = _d[1];
    // const [searchValue, setSearchValue] = useState<string>('');
    var _e = React.useState(false), hasMore = _e[0], setHasMore = _e[1];
    var _f = useState(null), searchData = _f[0], setSearchData = _f[1];
    var _g = useState(false), loading = _g[0], setLoading = _g[1];
    var _h = useState(false), visible = _h[0], setVisible = _h[1];
    var inputRef = useRef({});
    var keywordRef = useRef();
    var activeTypeRef = useRef();
    var _j = useState(SearchType.All), activeTabKey = _j[0], setActiveTabKey = _j[1];
    var tabsData = [
        { key: SearchType.All },
    ];
    var includeOrg = useMemo(function () {
        return lodashIncludes(tabs, 'org') || lodashIncludes(tabs, 'workLine');
    }, [tabs]);
    // 只能展示部门 不显示联系人
    if (!chooseOnlyDepart) {
        tabsData.push({ key: SearchType.Contacts });
    }
    if (includeOrg) {
        tabsData.push({ key: SearchType.Department });
    }
    if (lodashIncludes(tabs, 'group') || lodashIncludes(tabs, 'groupCanBeSel')) {
        tabsData.push({ key: SearchType.Group });
    }
    useEffect(function () {
        var _a, _b, _c, _d;
        if (visible) {
            (_b = (_a = document
                .getElementsByClassName('data-list-container')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.setAttribute('style', 'overflow: hidden !important');
        }
        else {
            (_d = (_c = document.getElementsByClassName('data-list-container')) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.removeAttribute('style');
        }
    }, [visible]);
    var clearData = useCallback(function (type) {
        if (!type) {
            // 保留搜索状态
            inputRef.current.blur();
            setVisible(false);
        }
        setActiveTabKey(SearchType.All);
        setSearchData(null);
        handleSetSearchValue('');
        activeTypeRef.current = null;
        keywordRef.current = null;
        setLoading(false);
        setHasMore(false);
        pageNo = 1;
        count = 0;
    }, [handleSetSearchValue]);
    var handleHasMore = useCallback(function (contacts, groups, depts) {
        switch (activeTabKey) {
            case SearchType.All:
                return false;
            case SearchType.Department:
                return (depts || []).length >= PAGE_SIZE;
            case SearchType.Group:
                return (groups || []).length >= PAGE_SIZE;
            case SearchType.Contacts:
                return (contacts || []).length >= PAGE_SIZE;
            default:
                return false;
        }
    }, [activeTabKey]);
    var doSearch = useCallback(function (pageNumber, theLastId) { return __awaiter(_this, void 0, void 0, function () {
        var data, list, datalist, contacts, groups, depts, hasMoreDepts, hasMoreGroups, hasMoreContacts, isEmpty, list_depts, list_contacts, list_groups, list, isHasMore;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(tabs.length === 1 &&
                        customTabs &&
                        customTabs.length > 0 &&
                        lodashIncludes(tabs, 'custom'))) return [3 /*break*/, 2];
                    return [4 /*yield*/, onSearchGroupMember(keywordRef.current, flatten(customTabs.map(function (item) { return item.dataList; })))];
                case 1:
                    list = _a.sent();
                    data = {
                        contacts: mapSearchCustomMember(list),
                    };
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, onSearchGlobal({
                        keyword: keywordRef.current,
                        searchType: activeTabKey,
                        pageNo: pageNumber,
                        pageSize: activeTabKey === SearchType.All ? 3 : PAGE_SIZE,
                    })];
                case 3:
                    datalist = _a.sent();
                    data = searchDataMapList({
                        searchData: datalist,
                        result: result,
                        frozenIds: frozenIds,
                        dataListFilter: dataListFilter,
                        searchValue: searchValue,
                        selectDept: chooseOnlyDepart || canSelectDept,
                        currentUser: currentUser,
                        selectGroupType: selectGroupType,
                        contactShowType: contactShowType,
                    });
                    _a.label = 4;
                case 4:
                    // 无网时返回字符串类型
                    if (typeof data === 'string') {
                        setSearchData(data);
                        return [2 /*return*/];
                    }
                    contacts = data.contacts, groups = data.groups, depts = data.depts, hasMoreDepts = data.hasMoreDepts, hasMoreGroups = data.hasMoreGroups, hasMoreContacts = data.hasMoreContacts;
                    if (!(keywordRef.current === searchValue && activeTabKey === activeTypeRef.current)) return [3 /*break*/, 6];
                    setLoading(false);
                    isEmpty = [contacts, groups, depts && depts.data].every(function (item) {
                        return !item || item.length === 0;
                    });
                    if (pageNumber === 1) {
                        if (isEmpty) {
                            setSearchData([]);
                            return [2 /*return*/];
                        }
                        setSearchData(data);
                    }
                    else {
                        list_depts = __assign(__assign({}, (data.depts || {})), { data: __spreadArrays((((searchData && searchData.depts) || {}).data || []), ((data.depts || {}).data || [])) });
                        list_contacts = __spreadArrays(((searchData && searchData.contacts) || []), (data.contacts || []));
                        list_groups = __spreadArrays(((searchData && searchData.groups) || []), (data.groups || []));
                        list = __assign(__assign({}, searchData), { contacts: list_contacts, groups: list_groups, depts: list_depts });
                        setSearchData(list);
                    }
                    return [4 /*yield*/, handleHasMore(contacts, groups, (depts && depts.data) || [])];
                case 5:
                    isHasMore = _a.sent();
                    setHasMore(isHasMore);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); }, [tabs, searchValue, activeTabKey, searchData]);
    var loadMore = null;
    if (hasMore) {
        loadMore = (React.createElement(LoadMore, { onClick: function () {
                pageNo = pageNo + 1;
                getSearchList(pageNo);
            } }, "\u52A0\u8F7D\u66F4\u591A"));
    }
    else {
        loadMore = canSelectStranger ? (React.createElement(LoadMore, null,
            "\u5C1D\u8BD5\u641C\u7D22\u5173\u4E8E\u201C",
            React.createElement("span", { onClick: function () {
                    onInputStrangerLeaveWordChange === null || onInputStrangerLeaveWordChange === void 0 ? void 0 : onInputStrangerLeaveWordChange((strangerLeaveWordInput === null || strangerLeaveWordInput === void 0 ? void 0 : strangerLeaveWordInput.placeholder) || '');
                    setNewMode(SelectorMode.stranger);
                    onAnalysisLog === null || onAnalysisLog === void 0 ? void 0 : onAnalysisLog('xtbg_add_home_1637657110163', '82');
                }, style: { color: colors.primary2 } }, searchValue),
            "\u201D\u7684\u975E\u8054\u7CFB\u4EBA")) : (React.createElement(LoadMore, null, "\u5DF2\u663E\u793A\u5168\u90E8"));
    }
    var getSearchList = useCallback(function (pageNumber) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    count++;
                    return [4 /*yield*/, doSearch(pageNumber, count)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [doSearch]);
    useEffect(function () {
        if (!lodashTrim(searchValue)) {
            return;
        }
        if (isChange) {
            return;
        }
        if (!activeTypeRef.current)
            activeTypeRef.current = SearchType.All;
        getSearchList(1);
    }, [isChange, activeTabKey, searchValue]);
    var handleTabIndex = useCallback(function (val) {
        if (activeTypeRef.current === val) {
            return;
        }
        setSearchData(null);
        setLoading(true);
        pageNo = 1;
        count = 0;
        activeTypeRef.current = val;
        setActiveTabKey(val);
    }, []);
    var handlePlaceHolder = useCallback(function () {
        if (chooseOnlyDepart) {
            return '搜索部门';
        }
        if (includeOrg &&
            (lodashIncludes(tabs, 'group') || lodashIncludes(tabs, 'groupCanBeSel'))) {
            return '搜索联系人/部门/群组';
        }
        if (includeOrg &&
            (!lodashIncludes(tabs, 'group') || !lodashIncludes(tabs, 'groupCanBeSel'))) {
            return '搜索联系人/部门';
        }
        if (includeOrg &&
            (lodashIncludes(tabs, 'group') || lodashIncludes(tabs, 'groupCanBeSel'))) {
            return '搜索联系人/群组';
        }
        return '搜索联系人';
    }, [tabs, includeOrg, chooseOnlyDepart]);
    var onGroupClick = useCallback(function (item) {
        var itemData = __assign(__assign({}, item), { id: item.groupId });
        jumpCurrentTabsGroup(itemData);
        clearData();
    }, [clearData, jumpCurrentTabsGroup]);
    var onOrgClick = useCallback(function (item) {
        var itemData = __assign(__assign({}, item), { deptId: item.id, name: typeof item.name === 'string' ? item.name : item.displayName || '', desc: typeof item.desc === 'string' ? item.desc : item.realDesc || '' });
        jumpCurrentTabsOrg(itemData);
        clearData();
    }, [clearData, jumpCurrentTabsOrg]);
    var onItemSelect = useCallback(function (item) {
        var itemData = __assign(__assign({}, item), { deptId: item.id, name: typeof item.name === 'string' ? item.name : item.displayName || '', desc: item.id
                ? ''
                : typeof item.desc === 'string'
                    ? item.desc
                    : item.realDesc || '' });
        onItemCheck(itemData);
    }, [onItemCheck]);
    useEffect(function () {
        // 关键字为空时保留搜索状态
        if (!searchValue) {
            clearData(true);
        }
    }, [clearData, searchValue]);
    var loadingNode = useMemo(function () {
        return (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '200px',
                background: '#fff',
            } },
            React.createElement(Loading, null)));
    }, []);
    var getTabPane = useCallback(function (item, t, onclick) {
        if (!searchValue) {
            return React.createElement(ListEmptyPlaceholder, { placeholder: "\u8F93\u5165\u5173\u952E\u8BCD\u67E5\u627E" });
        }
        if (!searchData) {
            return loadingNode;
        }
        if (typeof searchData === 'string') {
            return React.createElement(ListEmptyPlaceholder, { placeholder: "\u6682\u65E0\u6570\u636E" });
        }
        if (searchData.length === 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Empty, { image: searchNodata, description: React.createElement("span", null, "\u6682\u65E0\u6570\u636E") }),
                (activeTabKey === SearchType.All ||
                    activeTabKey === SearchType.Contacts) &&
                    canSelectStranger && (React.createElement("div", { style: { margin: '10px auto', textAlign: 'center' } },
                    "\u5C1D\u8BD5\u641C\u7D22\u5173\u4E8E\u201C",
                    React.createElement("span", { onClick: function () {
                            onInputStrangerLeaveWordChange === null || onInputStrangerLeaveWordChange === void 0 ? void 0 : onInputStrangerLeaveWordChange((strangerLeaveWordInput === null || strangerLeaveWordInput === void 0 ? void 0 : strangerLeaveWordInput.placeholder) || '');
                            setNewMode(SelectorMode.stranger);
                            onAnalysisLog === null || onAnalysisLog === void 0 ? void 0 : onAnalysisLog('xtbg_add_home_1637657110163', '82');
                        }, style: { color: colors.primary2 } }, searchValue),
                    "\u201D\u7684\u975E\u8054\u7CFB\u4EBA"))));
        }
        var props = {
            onclick: onclick,
            searchData: searchData,
            loading: loading,
            loadMore: loadMore,
            result: result,
            setTabIndex: handleTabIndex,
            searchValue: searchValue,
            getSearchExtraPart: getSearchExtraPart,
            onAnalysisLog: onAnalysisLog,
            onInputStrangerLeaveWordChange: onInputStrangerLeaveWordChange,
        };
        switch (activeTabKey) {
            case SearchType.All:
                return (React.createElement(SearchAllList, __assign({}, props, { onOrgClick: onOrgClick, onGroupClick: onGroupClick, onItemCheck: onItemSelect })));
            case SearchType.Contacts:
                return React.createElement(SearchContactsList, __assign({}, props));
            case SearchType.Department:
                return (React.createElement(SearchDepartmentList, __assign({}, props, { onOrgClick: onOrgClick, onItemCheck: onItemSelect })));
            case SearchType.Group:
                return React.createElement(SearchGroupList, __assign({}, props, { onGroupClick: onGroupClick }));
        }
    }, [
        activeTabKey,
        canSelectStranger,
        getSearchExtraPart,
        handleTabIndex,
        loadMore,
        loading,
        loadingNode,
        onAnalysisLog,
        onGroupClick,
        onInputStrangerLeaveWordChange,
        onItemSelect,
        onOrgClick,
        result,
        searchData,
        searchValue,
        setNewMode,
        strangerLeaveWordInput,
    ]);
    var tabName = useCallback(function (key) {
        switch (key) {
            case SearchType.All:
                return '全部';
            case SearchType.Contacts:
                return '联系人';
            case SearchType.Group:
                return '群';
            case SearchType.Department:
                return '部门';
            default:
                return '';
        }
    }, []);
    return (React.createElement("div", { className: "userSelection-search-container" },
        React.createElement("div", { className: "userSelection-search-input cursor-outline", style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }, onClick: function (event) {
                setSearchValue('');
                setVisible(true);
                inputRef.current && inputRef.current.focus();
                event.nativeEvent.stopImmediatePropagation();
            } },
            React.createElement("div", { className: "input-wrap" },
                React.createElement("span", { className: "icon-search" },
                    React.createElement("img", { src: searchIcon, alt: "" })),
                React.createElement("span", null, handlePlaceHolder()))),
        React.createElement("div", { className: visible
                ? 'userSelection-search-userSelection-modal-mask  userSelection-search-userSelection-translateY-mask'
                : 'userSelection-search-userSelection-modal-mask', onClick: function (e) {
                clearData();
            } }),
        React.createElement("div", { className: visible
                ? 'userSelection-search-userSelection-modal  userSelection-search-userSelection-translateY'
                : 'userSelection-search-userSelection-modal', onClick: function (event) {
                event.nativeEvent.stopImmediatePropagation();
            } },
            React.createElement("div", { className: "userSelection-search-input_container" },
                React.createElement("div", { className: "userSelection-search-input" },
                    React.createElement(SearchInput, { inputRef: inputRef, placeholder: handlePlaceHolder(), searchValue: searchValue, onSearchValueChange: function (val) {
                            handleSetSearchValue(val);
                            keywordRef.current = val;
                        }, onSetIsChange: function (val) {
                            setIsChange(val);
                        } }))),
            React.createElement("div", { className: "userSelection-search-content" },
                React.createElement(Tabs, { activeKey: activeTabKey, onChange: handleTabIndex }, tabsData.map(function (item) { return (React.createElement(TabPane, { key: item.key, tab: tabName(item.key) }, getTabPane(item, t, onItemCheck))); }))))));
}
export default GlobalSearchModal;
//# sourceMappingURL=index.js.map